    if (!customElements.get('product-card-slider')) {
      customElements.define(
        'product-card-slider',
        class ProductCardSlider extends HTMLElement {
          connectedCallback() {
            if (this.sliderInitialized) return;
            this.sliderInitialized = true;
            window.requestAnimationFrame(() => this.initSlider());
          }

          initSlider() {
            this.track = this.querySelector('[data-slider-track]');
            this.realSlides = Array.from(this.querySelectorAll('[data-slider-slide]'));
            this.dots = Array.from(this.querySelectorAll('[data-slider-dot]'));
            this.previousButton = this.querySelector('[data-slider-prev]');
            this.nextButton = this.querySelector('[data-slider-next]');
            this.currentIndex = 0;
            this.positionIndex = 0;
            this.startX = null;
            this.dragDelta = 0;
            this.wasDragged = false;
            this.cancelClick = false;

            if (!this.track || this.realSlides.length < 2) {
              if (this.track) this.track.style.transform = 'translateX(0)';
              return;
            }

            this.createInfiniteSlides();
            this.setTrackPosition(this.positionIndex, false);

            this.previousButton?.addEventListener('click', (event) => {
              event.preventDefault();
              event.stopPropagation();
              this.goToSlide(this.currentIndex - 1);
            });

            this.nextButton?.addEventListener('click', (event) => {
              event.preventDefault();
              event.stopPropagation();
              this.goToSlide(this.currentIndex + 1);
            });

            this.dots.forEach((dot, index) => {
              dot.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopPropagation();
                this.goToSlide(index);
              });
            });

            this.track.addEventListener('pointerdown', (event) => this.onPointerDown(event));
            this.track.addEventListener('pointermove', (event) => this.onPointerMove(event));
            this.track.addEventListener('pointerup', (event) => this.onPointerUp(event));
            this.track.addEventListener('pointercancel', (event) => this.onPointerUp(event));
            this.track.addEventListener('click', (event) => this.onTrackClick(event));
            this.track.addEventListener('transitionend', () => this.resetInfinitePosition());

            this.updateDots();
          }

          createInfiniteSlides() {
            const firstClone = this.realSlides[0].cloneNode(true);
            const lastClone = this.realSlides[this.realSlides.length - 1].cloneNode(true);

            firstClone.setAttribute('aria-hidden', 'true');
            firstClone.removeAttribute('data-slider-slide');
            lastClone.setAttribute('aria-hidden', 'true');
            lastClone.removeAttribute('data-slider-slide');

            this.track.prepend(lastClone);
            this.track.append(firstClone);
            this.positionIndex = 1;
          }

          onPointerDown(event) {
            if (event.button && event.button !== 0) return;

            this.startX = event.clientX;
            this.dragDelta = 0;
            this.wasDragged = false;
            this.track.style.transition = 'none';
            this.track.setPointerCapture?.(event.pointerId);
          }

          onPointerMove(event) {
            if (this.startX === null) return;

            this.dragDelta = event.clientX - this.startX;

            if (Math.abs(this.dragDelta) < 6) return;

            this.wasDragged = true;
            event.preventDefault();

            const width = this.track.clientWidth || 1;
            const baseOffset = this.positionIndex * -100;
            const dragOffset = (this.dragDelta / width) * 100;

            this.track.style.transform = 'translateX(' + (baseOffset + dragOffset) + '%)';
          }

          onPointerUp(event) {
            if (this.startX === null) return;

            const width = this.track.clientWidth || 1;
            const threshold = Math.min(80, width * 0.18);
            const direction = this.dragDelta < 0 ? 1 : -1;

            this.track.style.transition = '';
            this.track.releasePointerCapture?.(event.pointerId);

            if (Math.abs(this.dragDelta) > threshold) {
              this.goToSlide(this.currentIndex + direction);
            } else {
              this.setTrackPosition(this.positionIndex, true);
            }

            this.cancelClick = this.wasDragged;
            window.setTimeout(() => {
              this.cancelClick = false;
            }, 250);
            this.startX = null;
          }

          onTrackClick(event) {
            if (!this.cancelClick) return;

            event.preventDefault();
            event.stopPropagation();
            this.cancelClick = false;
          }

          goToSlide(index) {
            const slideCount = this.realSlides.length;

            if (!slideCount) return;

            this.currentIndex = (index + slideCount) % slideCount;

            if (index >= slideCount) {
              this.positionIndex = slideCount + 1;
            } else if (index < 0) {
              this.positionIndex = 0;
            } else {
              this.positionIndex = index + 1;
            }

            this.setTrackPosition(this.positionIndex, true);
            this.updateDots();
          }

          setTrackPosition(positionIndex, animate) {
            this.track.style.transition = animate ? '' : 'none';
            this.track.style.transform = 'translateX(-' + positionIndex * 100 + '%)';

            if (!animate) {
              this.track.offsetHeight;
              this.track.style.transition = '';
            }
          }

          resetInfinitePosition() {
            const slideCount = this.realSlides.length;

            if (this.positionIndex === slideCount + 1) {
              this.positionIndex = 1;
              this.setTrackPosition(this.positionIndex, false);
            } else if (this.positionIndex === 0) {
              this.positionIndex = slideCount;
              this.setTrackPosition(this.positionIndex, false);
            }
          }

          updateDots() {
            this.dots.forEach((dot, dotIndex) => {
              dot.classList.toggle('is-active', dotIndex === this.currentIndex);
            });
          }
        }
      );
    }
